const disableVerticalSwipe = (): void => {
  if (window.Telegram.WebApp.isVerticalSwipesEnabled) {
    window.Telegram.WebApp.disableVerticalSwipes();
  }
};

export default disableVerticalSwipe;
